import * as React from "react";
import { useMobileMediaQuery } from "../hooks/useMobileMediaQuery";

type Props = { children: React.ReactNode; style?: React.CSSProperties };

export const ButtonContainer = ({ children, style }: Props) => {
    const isMobile = useMobileMediaQuery();

    return (
        <div
            style={{
                marginBottom: isMobile ? 0 : 48,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: isMobile ? "column-reverse" : "row",
                width: "100%",
                ...style
            }}
        >
            {children}
        </div>
    );
};
